// npm
import React, { Fragment, useState } from 'react'
import {
  useRecoilState,
} from 'recoil'
import {
  Routes,
  Route,
  Link,
} from "react-router-dom"
import { Dialog, Transition } from '@headlessui/react'
import {
  BellIcon,
  CalendarIcon,
  ChartBarIcon,
  FolderIcon,
  HomeIcon,
  InboxIcon,
  MenuIcon,
  MenuAlt2Icon,
  SearchIcon,
  UsersIcon,
  XIcon,
} from '@heroicons/react/outline'

// local
import { isSidebarOpenState } from "../lib/state.js"
import classNames from '../lib/class-names.js'

// components
import ProfileDropdown from '../components/ProfileDropdown.jsx'
import StaticSidebar from '../components/StaticSidebar.jsx'
import TopNavBar from '../components/TopNavBar.jsx'
import MobileNav from '../components/MobileNav.jsx'

// pages
import Home from '../routes/Home.jsx'
import Url from '../routes/Url.jsx'
import Image from '../routes/Image.jsx'
import Text from '../routes/Text.jsx'
import DomainPage from '../routes/DomainPage.jsx'
import NotFound from '../routes/NotFound.jsx'

export default function Dashboard() {
  const [ isSidebarOpen, setIsSidebarOpen ] = useRecoilState(isSidebarOpenState)

  return (
    <>
      <div>
        <Transition.Root show={ isSidebarOpen } as={ Fragment }>
          <Dialog as="div" className="relative z-40 md:hidden" onClose={ setIsSidebarOpen }>
            <Transition.Child
              as={Fragment}
              enter="transition-opacity ease-linear duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="transition-opacity ease-linear duration-300"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-600 bg-opacity-75" />
            </Transition.Child>

            <div className="fixed inset-0 flex z-40">
              <Transition.Child
                as={Fragment}
                enter="transition ease-in-out duration-300 transform"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transition ease-in-out duration-300 transform"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
              >
                <Dialog.Panel className="relative flex-1 flex flex-col max-w-xs w-full pt-5 pb-4 bg-indigo-700">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-300"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                  >
                    <div className="absolute top-0 right-0 -mr-12 pt-2">
                      <button
                        type="button"
                        className="ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white"
                        onClick={ () => setIsSidebarOpen(false) }
                      >
                        <span className="sr-only">Close sidebar</span>
                        <XIcon className="h-6 w-6 text-white" aria-hidden="true" />
                      </button>
                    </div>
                  </Transition.Child>
                  <div className="flex-shrink-0 flex items-center px-4">
                    <img
                      className="h-8 w-auto"
                      src="https://tailwindui.com/img/logos/workflow-logo-indigo-300-mark-white-text.svg"
                      alt="Workflow"
                    />
                  </div>
                  <div className="mt-5 flex-1 h-0 overflow-y-auto">

                    <MobileNav />

                  </div>
                </Dialog.Panel>
              </Transition.Child>
              <div className="flex-shrink-0 w-14" aria-hidden="true">
                {/* Dummy element to force sidebar to shrink to fit close icon */}
              </div>
            </div>
          </Dialog>
        </Transition.Root>

        { /* Static sidebar for desktop */ }
        <div className="hidden md:flex md:w-64 md:flex-col md:fixed md:inset-y-0">
          <StaticSidebar />
        </div>

        { /* TopNavBar plus <main> */ }
        <div className="md:pl-64 flex flex-col flex-1">

          <TopNavBar />

          <main>

            <div className="py-8">

              <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">

                <Routes>
                  <Route caseSensitive path="/" element={ <Home /> } />
                  <Route caseSensitive path="/:domainName/url/" element={ <Url /> } />
                  <Route caseSensitive path="/:domainName/image/" element={ <Image /> } />
                  <Route caseSensitive path="/:domainName/text/" element={ <Text /> } />
                  <Route caseSensitive path="/:domainName/" element={ <DomainPage /> } />
                  <Route path="*" element={ <NotFound /> } />
                </Routes>

              </div>

            </div>

          </main>

        </div>
      </div>
    </>
  )
}
